module.exports = __webpack_public_path__ + "static/media/sailec-black.9456b8a6.woff";